import { style } from '@vanilla-extract/css';

export const serviceEmbedContainer = style({});

export const youtubeFacade = style({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  padding: 0,
  border: 0,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#000',
  selectors: {
    '&:focus-visible': { outline: '2px solid #fff', outlineOffset: '2px', boxShadow: '0 0 0 6px #000' },
  },
});

export const youtubeThumbnail = style({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const youtubePlayIcon = style({
  position: 'relative',
  display: 'flex',
});
